import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../../../utils/translator.helper';

@customElement('gz-grid-cell-link')
export class GridCellLinkWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  linkMessage = '';

  @property({ type: String, attribute: true, reflect: true })
  clipboardMessage;

  @property({ type: String, attribute: true, reflect: true })
  copyContentMessage = translateFn('Copied');

  @property({ type: Function })
  public onLinkClick: Function;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-link type="quiet" color="primary" @click=${this.onLinkClick}> ${this.linkMessage}</gz-link>
      <gz-copy-to-clipboard
        .confirmationMessage="${this.copyContentMessage}"
        .clipboardMessage="${this.clipboardMessage}"
        showIconOnHover="true"
        style="left: ${this.calculateDynamicWidth()};"
      >
      </gz-copy-to-clipboard>
    `;
  }

  private calculateDynamicWidth(): string {
    return this.linkMessage.length * 5 + 'px';
  }
}
